import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { SCREEN_SIZE } from "@static/screen-size";
import { themeDefault } from "src/theme-revamp";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import { ROUTE_PATH } from "@static/route-paths";
import React, { useCallback, useEffect, useState } from "react";
import InnerContainer from "@pages/EverGreen/Components/InnerContainer";
import Button from "@components/_Revamp/Button";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { PRODUCT_CODE_API, postValidateAdviser } from "@api/index";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateAssignedAgentOption,
  updateFinancialAdviser,
  updateFARData,
} from "@redux/slices/CCP/step6Slice";
import { mask } from "@utils/mask";
import { LoadingScreen } from "@utils/helpers";
import Accordion from "@components/_Revamp/Accordion";
import { Text } from "@components/_Shared/Text";
import Bullet from "@components/_Revamp/Bullet";
import { useHistory } from "react-router-dom";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import ArcForm from "./ArcForm";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";

export const Mapper: Record<string, string> = {
  "no-adviser": "NO_AGENT",
  "singlife-adviser": "ARISTOTLE",
  "own-adviser": "USER_PREFERRED",
};

function FinancialAdviser() {
  const [adviserName, setAdviserName] = useState("");
  const [error, setError] = useState("");
  const selectedOption = useAvivaSelector(
    (state) => state.cancerCoverStep6.financialAdviser.autoAssignAgent
  );
  const adviser = useAvivaSelector(
    (state) => state.cancerCoverStep6.financialAdviser.adviserData
  );
  const customerId = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo.customerId
  );
  const declarationAcceptance = useAvivaSelector(
    (state) => state.cancerCoverStep6.declarationAcceptance
  );
  const { FARData, financialAdviserLink, financialAdviser, showArcPage } =
    useAvivaSelector((state) => state.cancerCoverStep6);
  const [isOwnOption, setOwnOption] = useState(() => {
    if (selectedOption === "own-adviser") {
      return true;
    }
    return false;
  });
  const campaignData = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const encryptedPromoCode = useAvivaSelector(
      (state) => state.cancerCoverStep6.promoCode
    );
  const dispatch = useAvivaDispatch();
  const [farCodeState, setFarCode] = useState(FARData.code || "");
  const history = useHistory();

  // Get the FAR name and details from the store

  const FAROptionHandler: React.MouseEventHandler<HTMLDivElement> = useCallback(
    async (e) => {
      // trackOnFormStartOrSuccess("DS_financial_adviser_form")
      const option = e.target as HTMLDivElement;
      let prevSelected = selectedOption;
      if (option?.getAttribute("data-far") === "own-adviser") {
        dispatch(updateAssignedAgentOption(""));
        setOwnOption(true);
        return;
      } else {
        setOwnOption(false);
      }
      try {
        const flag = await validateFarCode(option);
        if (flag) {
          prevSelected = "";
          dispatch(
            updateAssignedAgentOption(option?.getAttribute("data-far")!)
          );
          dispatch(updateFARData({ isNeed: selectedOption }));
        }
      } catch {
      } finally {
        if (prevSelected === "own-adviser") {
          setOwnOption(true);
        }
      }
    },
    [selectedOption]
  );

  const validateFarCode = async (option?: HTMLDivElement) => {
    try {
      LoadingScreen();
      const agentSelectedType =
        Mapper[
          (option?.getAttribute && option?.getAttribute("data-far")) ||
            "own-adviser"
        ];
      const payload = {
        agentCode: farCodeState.replaceAll(" ", "") || "",
        promoCode: encryptedPromoCode,
        clientNo: "",
        loggedInUserId: 0,
        loginUser: "",
        requesterClientNumber: "",
        sourceSystem: "CCP",
        agentSelectedType,
        customerId: Number(customerId),
      };
      const { data } = await postValidateAdviser(
        farCodeState.replaceAll(" ", ""),
        PRODUCT_CODE_API.CANCER_COVER,
        payload
      );

      if (["NO_AGENT", "ARISTOTLE"].includes(agentSelectedType)) {
        return true;
      }
      if (
        data?.data &&
        data?.data?.fullName &&
        data?.data?.agentTerminatedFlag !== "Y"
      ) {
        //update the store
        // if (data?.data?.fullName) {
        //   data.data.fullName = mask(data?.data?.fullName);
        // }
        dispatch(updateFinancialAdviser(data));
        dispatch(updateAssignedAgentOption("own-adviser"));
        const agentName = data?.data?.fullName;
        setAdviserName(
          `${agentName} has been assigned as your Financial Adviser Representative for this policy`
        );
        // setAdviserName(
        //   "Your Financial Adviser Representative has been assigned to this policy."
        // );
        setError("");
      } else {
        setAdviserName("");
        setError(
          "We couldn't find an adviser with the code you provided. Try another code."
        );
        dispatch(updateFinancialAdviser({ data: null }));
      }
      return true;
    } catch (e) {
      //TODO update the error screen route
      trackOnLoad({errorPage:{errorCode:"500", errorMsg:"adviser validation api called failed"}})
      history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);

      console.error(e);
    } finally {
      LoadingScreen(false);
    }
  };

  const disbaleBtn = () => {
    return Boolean(
      !selectedOption ||
        (selectedOption === "own-adviser" &&
          (!adviser?.data?.fullName ||
            adviser?.data?.agentTerminatedFlag === "Y" ||
            !!error))
    );
  };

  useEffect(() => {
    if (
      adviser.data?.fullName &&
      adviser.data.agentTerminatedFlag !== "Y" &&
      FARData.code
    ) {
      // const agentName = mask(adviser?.data?.fullName);
      setAdviserName(
        // `${agentName} has been assigned as your Financial Adviser Representative for this policy`
        `Your Financial Adviser Representative has been assigned to this policy.`
      );
    }
  }, []);

  //AA
  useEffect(() => {
    trackOnLoad();
  }, []);
  //AA on load
  //   useEffect(()=>{
  // if (!declarationAcceptance) return;
  //     trackOnLoad()
  //   },[])

  // if (!declarationAcceptance) {
  //   history.replace(ROUTE_PATH.EVER_GREEN_DOCUMENT_REVIEW);
  //   return null;
  // }

  if (
    FARData.code &&
    financialAdviser.adviserData.data?.fullName &&
    financialAdviser.adviserData.data?.agentTerminatedFlag !== "Y" &&
    financialAdviserLink &&
    financialAdviser.autoAssignAgent === "own-adviser" &&
    showArcPage
  ) {
    return <ArcForm />;
  }

  return (
    // TODO update the back button route
    <HealthMainContainer
      backButtonPath={ROUTE_PATH.CANCER_COVER_DECLARATION}
      stepList={[]}
      step={3}
    >
      <InnerContainer>
        <div style={{ maxWidth: "588px", margin: "auto" }}>
          <Header>
            Do you need a Financial Adviser Representative to service this
            policy?
          </Header>
        </div>
        <ButtonNFarSearch>
          <ButtonContainer>
            <RectSelector
              data-far="no-adviser"
              isSlected={selectedOption === "no-adviser"}
              onClick={FAROptionHandler}
            >
              No, I do not need an adviser
            </RectSelector>

            <RectSelector
              data-far="singlife-adviser"
              isSlected={selectedOption === "singlife-adviser"}
              onClick={FAROptionHandler}
            >
              Yes, assign an adviser to me
            </RectSelector>
            <RectSelector
              data-far="own-adviser"
              isSlected={selectedOption === "own-adviser" || isOwnOption}
              onClick={FAROptionHandler}
            >
              Yes, I want to assign my own adviser
            </RectSelector>
          </ButtonContainer>
          <FARSearchContainer isShow={isOwnOption}>
            <div>
              <div>
                <InputGroup
                  id="far-code"
                  inputProps={{
                    textAlign: "left",
                    value: farCodeState,
                  }}
                  theme={themeDefault}
                  onChange={(e) =>
                    setFarCode((prev) => {
                      if (e.target.value.length > 9) {
                        return prev;
                      }
                      let input = e.target.value.trim();
                      const regex = /^[0-9]{0,4}\s{0,1}[0-9]{0,4}$/;
                      if (!regex.test(input)) {
                        return prev;
                      }
                      if (input.includes(" ")) {
                        input = input.slice(0, 4) + " " + input.slice(5);
                      } else if (input.length > 4) {
                        input = input.slice(0, 4) + " " + input.slice(4);
                      }
                      dispatch(
                        updateFARData({
                          code: input?.replaceAll(" ", "") || input,
                        })
                      );
                      return input;
                    })
                  }
                  inputType="input"
                  label="Financial Adviser Representative Code"
                />
                {adviserName && (
                  <div className="adviser-res">{adviserName}</div>
                )}
                {error && (
                  <div className="adviser-res adviser-error">{error}</div>
                )}
              </div>
              <Button
                label="Find adviser"
                disabled={farCodeState.length < 9}
                data-far="own-adviser"
                onClick={validateFarCode}
                theme={themeDefault}
                variant="secondary"
              />
            </div>
          </FARSearchContainer>
        </ButtonNFarSearch>
      </InnerContainer>
      <ContinueContainer>
        <Button
          theme={themeDefault}
          width="180px"
          onClick={() => {
            //  trackOnFormStartOrSuccess("DS_financial_adviser_form", true)
            trackOnCTA({
              ctaText: "Continue",
              ctaType: "qb:link",
            });
            history.push(ROUTE_PATH.CANCER_COVER_REVIEW);
          }}
          disabled={disbaleBtn()}
          label="Continue"
        />
      </ContinueContainer>
      <div>
        <Accordion {...accordionArgs}>
          <div style={{ paddingBottom: "20px", maxWidth: "740px" }}>
            <Bullet>
              <Text variant="base" fontSize="12px">
                If you are an existing Singlife customer, we’ll assign the
                latest active representative, either from Singapore Life Ltd. or
                from our distribution partners, who had sold our plans to you.
              </Text>
            </Bullet>
            <Bullet>
              <Text variant="base" fontSize="12px">
                If you are a new customer of Singlife or don't have an active
                representative who have sold a Singlife plan to you, we'll
                assign a dedicated Singlife Relationship Consultant.
              </Text>
            </Bullet>
          </div>
          <Text
            variant="base"
            fontSize="12px"
            padding="0 0 20px"
            maxWidht={759}
          >
            Once you've completed your purchase, we'll email you the details of
            the assigned Financial Adviser Representative who will be servicing
            your policy.
          </Text>
        </Accordion>
      </div>
    </HealthMainContainer>
  );
}

export default FinancialAdviser;

const ContinueContainer = styled.div`
  margin: 64px auto;
  display: flex;
  justify-content: center;
  button:disabled {
    background-color: #d4bfd7;
    color: white;
  }
`;

const Header = styled.div<{ marginTop?: string }>`
  max-width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin: 0 auto 24px auto;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 64px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const FARSearchContainer = styled.div<{ isShow: boolean }>`
  width: 100%;
  margin-top: 24px;
  height: ${(props) => (props.isShow ? "100%" : "0px")};
  overflow: hidden;
  transition: all 0.3s linear;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    height: ${(props) => (props.isShow ? "120px" : "0px")};
  }
  div {
    width: 100%;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      display: flex;
    }
    div:first-child {
      flex: 2;
      display: flex;
      flex-direction: column;
      div > label {
        margin-bottom: 10px;
      }
      .adviser-res {
        color: #19d3c5;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 10px;
        line-height: 140%; /* 16.8px */
        letter-spacing: 0.18px;
        margin-top: 8px;
        @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
          margin-bottom: 10px;
        }
      }
      .adviser-error {
        color: #c50000;
      }
    }
    button {
      flex: 1;
      margin-top: 25px;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        margin-top: 10px;
        margin-left: 24px;
      }
    }
  }
`;
const ButtonNFarSearch = styled.div`
  max-width: 664px;
  padding: 0px 20px;
  margin: auto;
`;

const RectSelector = styled.div<{ isSlected: boolean }>`
  max-width: 616px;
  font-size: 14px;
  width: inherit;
  border-radius: 8px;
  text-align: center;
  padding: 15px 24px;
  margin: auto 20px;
  font-weight: 600;
  background-color: ${(props) =>
    props.isSlected
      ? themeDefault.colors.primary
      : themeDefault.colors.grey[700]};
  color: ${(props) =>
    props.isSlected
      ? themeDefault.colors.white
      : themeDefault.colors.grey[1200]};
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: #883E89;
    color: #FFFFFF;
  }
`;

const container_default_css = css`
  margin-bottom: 130px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  color: #434343;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  width: unset;
  font-size: 14px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 16px;
  }
`;

const accordionArgs = {
  title:
    "Things to note when we assign a Financial Adviser Representative to you:",
  theme: themeDefault,
  className: container_default_css,
  titleClassName: title_default_css,
  headerPadding: "24px 24px 24px 0",
  titleFontSize: 14,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
  headerBackgroundColor: "#F4F6F9",
  showHeaderBackground: true,
};
